import React from "react";
import { ArrowRight } from "lucide-react";
import { LOGO_COLOR, LOGIN_HREF } from "./constants";

export const Navbar = () => (
    <header
        className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm border-b border-slate-100"
        data-testid="site-header"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex h-20 items-center justify-between">
                <a
                    href="#inicio"
                    className="flex items-center gap-3 group"
                    data-testid="navbar-brand"
                >
                    <img
                        src={LOGO_COLOR}
                        alt="Lotería de Falcón"
                        className="h-14 w-14 object-contain transition-transform duration-300 group-hover:scale-105"
                        data-testid="navbar-logo"
                    />
                </a>

                <nav
                    className="hidden md:flex items-center gap-10"
                    aria-label="Navegación principal"
                >
                    <a
                        href="#mision"
                        className="text-sm font-medium text-slate-600 hover:lf-text-blue transition-colors"
                        data-testid="nav-link-mision"
                    >
                        Misión
                    </a>
                    <a
                        href="#valores"
                        className="text-sm font-medium text-slate-600 hover:lf-text-blue transition-colors"
                        data-testid="nav-link-valores"
                    >
                        Valores
                    </a>
                    <a
                        href="#inicio"
                        className="text-sm font-medium text-slate-600 hover:lf-text-blue transition-colors"
                        data-testid="nav-link-inicio"
                    >
                        Institucional
                    </a>
                    <a
                        href={LOGIN_HREF}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="lf-cta lf-cta-sm group"
                        data-testid="nav-login-button"
                    >
                        <span className="lf-cta-shine" />
                        <span className="relative z-10">Inicia Sesión</span>
                        <ArrowRight
                            size={15}
                            strokeWidth={2.5}
                            className="relative z-10 transition-transform duration-300 group-hover:translate-x-0.5"
                        />
                    </a>
                </nav>
            </div>
        </div>
    </header>
);
